/// <amd-module name="Search/Shared/Components/NotificationArea/NotificationArea" />

import * as React from "react";
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Link } from "VSSUI/Link";
import { INotificationAreaProps, INotificationProps } from "./NotificationArea.Props";

export class NotificationArea extends React.Component<INotificationAreaProps, INotificationProps> {
    constructor(props: INotificationAreaProps) {
        super(props);
        this.state = {
            visible: false,
            message: "",
            severity: MessageBarSeverity.Info,
            isFormatted: false
        };
    }

    public render(): JSX.Element | null {
        const {
            message,
            severity,
            visible,
            isFormatted,
            link,
            linkLabel,
            onLinkClick
        } = this.state;

        return (
            visible ?
                <MessageBar
                    className="search-notification-bar"
                    severity={severity}
                    onDismiss={this.onDismiss} >
                    {
                        isFormatted ?
                            <FormatComponent format={message}>
                                <Link href={link}
                                    onClick={onLinkClick} target="_blank">
                                    {linkLabel}
                                </Link>
                            </FormatComponent>
                            : message
                    }
                </MessageBar>
                : null
        );
    }

    public componentDidMount(): void {
        this.props.notification.subscribe(this.onNotificationUpdated);
    }

    public componentWillUnmount(): void {
        this.props.notification.unsubscribe(this.onNotificationUpdated);
    }

    private onNotificationUpdated = (notificationPros: INotificationProps): void => {
        this.setState(notificationPros);
    }

    private onDismiss = (): void => {
        const { onDismiss } = this.state;
        this.setState(
            { visible: false },
            () => {
                if (onDismiss) {
                    onDismiss();
                }
            });
    }
}